/**
 * Browser stub for CounterManager (no fs/path in the browser).
 *
 * The counter store is SERVER state: it persists to App_Data/CounterData.json, which a browser has no
 * access to. The browser registrar constructs `new RegisterBase()` with no manager, so every counter
 * handler falls back to the per-merge transient value and no instance of this class is ever created.
 * Only the static key builder is reachable from the bundled CounterAction/CounterData, and it is pure
 * string work — kept byte-identical to the server implementation so a key built client-side and one
 * built server-side cannot diverge.
 *
 * Wired in Assembler/build.ts alongside the existing LoggerBrowser and EnvUtilityBrowser redirects.
 */
export class CounterManager {
    /**
     * Builds the store key. The AppSite is part of the key because the same component name (e.g. "Counter")
     * is bound in more than one AppSite, and those counters are independent.
     */
    static buildCounterKey(appSite: string, componentName: string, counterKey: string): string {
        return appSite + ':' + componentName + ':' + counterKey;
    }

    get appSite(): string {
        return 'Counter';
    }

    reload(): void {
        // No persisted store in the browser — nothing to reload.
    }

    tryGetValue(key: string): { found: boolean; value: number } {
        void key;
        return { found: false, value: 0 };
    }

    setValue(key: string, value: number): void {
        void key;
        void value;
    }
}
